var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 15",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.507 2.806l2.466 2.466a.267.267 0 010 .378l-5.972 5.972-2.537.281a.534.534 0 01-.588-.588l.281-2.537 5.972-5.972a.267.267 0 01.378 0zm4.43-.626L14.601.845a1.075 1.075 0 00-1.51 0l-.967.968a.267.267 0 000 .378l2.466 2.466a.269.269 0 00.377 0l.968-.968a1.075 1.075 0 000-1.51l.002.001zm-4.939 7.817v2.784h-8.75V4.03h6.284c.087 0 .17-.036.232-.096L9.858 2.84a.33.33 0 00-.232-.56H1.811c-.725 0-1.313.588-1.313 1.312v9.625c0 .725.588 1.313 1.313 1.313h9.624c.725 0 1.313-.588 1.313-1.313V8.904a.33.33 0 00-.56-.233l-1.094 1.094a.335.335 0 00-.096.232z",
    fill: "#d4366a",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0c36e9d0b2e63b7cdf8e3f40304c8e7f.svg";
export { ForwardRef as ReactComponent };